import React from "react";
import Image from "react-bootstrap/Image";
import AddDinerPopup from "../../reusableComponents/allPopupReusable/addDinerAndAddReservation/AddDinerPopup";
import OfferPopup from "../../reusableComponents/allPopupReusable/offerEventPopup/OfferPopup";
import EventPopup from "../../reusableComponents/allPopupReusable/offerEventPopup/EventPopup";
import { NavLink } from "react-router-dom";

export const TopNavigationBarMobile = ({
  displayLeft,
  displayRight,
  backLink,
  headText,
}) => {
  try {
    return (
      <React.Fragment>
        <div>
          {displayLeft === "logo" ? (
            <Image
              className="logo-image"
              src={require("../../../assets/images/Login/logomobile.png")}
              alt="Amealio Logo"
              title="Amealio"
              fluid
            />
          ) : null || displayLeft === "backButton" ? (
            <NavLink to={backLink} className="back-button-image-text">
              <Image
                className="back-button-Image"
                src={require("../../../assets/images/ActionImages/backbutton.png")}
                alt="Back"
                title="Back Button"
                fluid
              />
              <p className="back-button-text">{headText}</p>
            </NavLink>
          ) : null}
        </div>
        <div>
          {displayRight === "addDiner" ? (
            <AddDinerPopup />
          ) : null || displayRight === "addOffer" ? (
            <OfferPopup bigText="Add New Offer" />
          ) : null || displayRight === "addEvent" ? (
            <EventPopup bigText="Add New Event" />
          ) : null || displayRight === false ? null : null}
        </div>
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
};
